interface modalSettings {
    leftInput?: any
    submitBtn?: any
    size?: boolean
    centered?: boolean
    closeBtn?: boolean
    draggable?: boolean
    fill?: boolean
    faq?: number|boolean
    id?: number
}

export function makeEditorModal(id, title, content, settings:modalSettings = {}, onclick:Function=function(){}, listeners:Function=function(){}){
    const s:modalSettings = {};
    s.leftInput = (settings.leftInput !== undefined) ? settings.leftInput : {};
    s.submitBtn = (settings.submitBtn !== undefined) ? settings.submitBtn : {};
    s.size = (settings.size !== undefined) ? settings.size : false;
    s.centered = (settings.centered !== undefined) ? settings.centered : true;
    s.closeBtn = (settings.closeBtn !== undefined) ? settings.closeBtn : false;
    s.draggable = (settings.draggable !== undefined) ? settings.draggable : true;
    s.fill = (settings.fill !== undefined) ? settings.fill : true; // if fill = false -> not reinitiated
    s.faq = (settings.faq !== undefined) ? settings.faq : false;
    s.id = (settings.id !== undefined) ? settings.id : 0;
    const faqSign = (s.faq) ? '<span class="fast-faq ms-3" onclick="showQuestion('+ s.faq+ ');"><i class="fa fa-question-circle"></i></span>' : '';
    if (document.getElementById(id) != undefined){
        return editEditorModal(id, title, content, s.leftInput.value,  s.id, s.fill);
    } else {
        let modal = `<div id="${id}" class="modal fade" role="dialog">
  <div class="modal-dialog`;
        if (s.size) {
            modal += ' modal-' + s.size;
        }
        if (s.centered){
            modal += ' modal-dialog-centered';
        }
        modal += `">
    <!-- Modal content-->
    <div class="modal-content">
        <div class="modal-header d-flex align-items-center border-bottom">
                <span class="h4 modal-title">${title}</span> ${faqSign}
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      <div class="modal-body">
        ${content}
      </div>
      <div class="modal-footer border-top">`;
        if (!jQuery.isEmptyObject(s.leftInput)){
            if (s.leftInput.html !== undefined){
                modal += s.leftInput.html;
            } else {
                const width = (s.leftInput.width !== undefined) ? s.leftInput.width : '100px';
                modal += `<input type="${s.leftInput.type}" class="left-input boxen form-control form-control-lg" style="width: ${width};"`
                if (s.leftInput.value){
                    modal += ` value="${s.leftInput.value}"`
                } else {
                    modal += ` placeholder="${s.leftInput.placeholder}"`
                }
                modal += '>';
                if (s.leftInput.text){
                    modal += ' <span class="ms-2">' + s.leftInput.text + '</span>';
                }
            }
        }
        modal += '<div class="ms-auto">'
        if (s.close) {
            modal += `<button type="button" class="btn btn-info waves-effect" data-bs-dismiss="modal">Schließen</button>`;
        }
        if (!jQuery.isEmptyObject(s.submitBtn)) {
            const data = (s.submitBtn.data !== undefined) ? s.submitBtn.data : '';
            modal += `<button data-id="${s.id}" class="${s.submitBtn.class} btn btn-lg btn-light-success text-success font-weight-medium sub" type="button" ${data}>${s.submitBtn.text}</button>`;
        }
        modal += '</div>';
        modal += `</div>
        </div>
      </div>
    </div>`;
        $(document.body).append(modal);
        const m = document.getElementById(id);
        const myModal = new bootstrap.Modal(m, {
            keyboard: true,
            focus: true,
            backdrop: false,
        });
        myModal.show();

        // What to do on submit?
        const jM = $(m);
        const execute = function(){
            const check = onclick(this)
            if (check){
                myModal.hide();
            }
        };
        jM.on("click", ".sub", execute.bind(jM));

        // addListeners
        listeners($(m));

        // make draggable
        if (s.draggable){
            jM.draggable({
                handle: ".modal-header"
            });
        }
        return myModal;
    }
}



export function editEditorModal(id:string, title:string, content:string, leftInputValue, inputId=0, fill=true){
    if (fill) {
        const modal = $("#" + id);
        modal.find(".modal-title").html(title);
        modal.find(".modal-body").html(content);
        if (leftInputValue) {
            modal.find(".left-input").val(leftInputValue);
        }
        modal.find(".sub").attr('data-id', inputId);

    }
    const existingModal = bootstrap.Modal.getInstance(document.getElementById(id));
    existingModal.show();
    return existingModal;
}

